import React, { useRef, useState, useEffect } from "react";
import CallIcon from "@mui/icons-material/Call";
import cssClasses from "../AllAllotments.module.css";
import { Box, Card, Grid, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import {
  getCRMTimelineData,
  getCancellationsCrmAllotments,
  getVirtualAccDetailsById,
} from "../../../Services/AllAllotments";
import { errorTost, successTost } from "../../../Services/Toast";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { makeStyles } from "@mui/styles";
import ReactTimeAgo from "react-time-ago";
import _, { debounce } from "lodash";
import SearchBar from "../../../Subcomponents/Search";
import AllotmentFilter from "./AllotmentFilter";
import ViewToggleSwitch from "../../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import AllotmentSortFilter from "./AllotmentSortFIlter";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import ServerPaginationGrid from "../../ServerPaginationGrid";
import { supabase } from "../../../supabaseClient";
import ViewAllotedCrmDetailsModal from "./ViewAllotedCrmDetailsModal/ViewAllotedCrmDetailsModal";
import CrmTimeLineModal from "./CRMTimeLineModal/CrmTimeLineModal";
import { getLeadVirtualAccountStatus } from "../../../Services/Lead";
import UpdateLeadDetails from "./CheckVirtualAccountStatus/CheckVirtualAccountStatus";

const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

function Cancellations() {
  const classes = useStyles();

  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allCrmAllotments, setAllCrmAllotments] = useState([]);
  const hasMore = useRef(true);
  const pageNumber = useRef(0);
  const searchValue = useRef("");
  const [mode, setMode] = useState("Card View");
  const [
    selectedAllotmentForViewCrmDetails,
    setSelectedAllotmentForViewCrmDetails,
  ] = useState(null);
  const [emailSentCount, setEmailSentCount] = useState(0);
  const [checked, setChecked] = React.useState([]);
  const [filterBy, setFilterBy] = useState("Latest First");
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [depStr, setDepQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [crmTimeLineModalToggle, setcrmTimeLineModalToggle] = useState(false);
  const [crmTimeLineModalData, setCrmTimeLineModalData] = useState([]);
  const [leadDisplayId, setLeadDisplayId] = useState("")
  const [virtualAccountStatusModal, setVirtualAccountStatusModal] = useState(false)
  const [allotmentData, setAllotmentData] = useState([])
  const isInitialRender = useRef(true);

  const tagGridColumns = [
    {
      field: "unit",
      headerName: "Unit",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {params?.row?.displaywingname
                      ? params?.row?.displaywingname
                      : params?.row?.wing_name}{" "}
                    - {params?.row?.unit_no}{" "}
                  </span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {/* {params?.row?.merged_wing_name} -{" "} */}
                    {params?.row?.mergeddisplaywingname
                      ? params?.row?.mergeddisplaywingname
                      : params?.row?.merged_wing_name}{" "}
                    - {params?.row?.merged_unit_no_one} {"-"}{" "}
                    {params?.row?.merged_unit_no_two}{" "}
                  </span>
                )}
              </div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>{params?.row?.project_name}</span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>{params?.row?.merged_project_name}</span>
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "allotmentId",
      headerName: "Allotment Id",
      width: 200,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>{params.row?.allotment_payment_id}</p>
              </div>
            }
          >
            <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
              {params.row?.allotment_payment_id}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "leadsDetails",
      headerName: "Leads Name",
      width: 230,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p style={{ whiteSpace: "break-spaces" }}>
                  {params.row?.lead_name}
                </p>
              </div>
            }
          >
            <div>
              <p style={{ whiteSpace: "break-spaces" }}>
                {params.row?.lead_name}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Email Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {params?.row?.isemailsent ? (
                  <LeadStatusChip
                    label={"Email Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#6941C6",
                      backgroundColor: "#F4EBFF",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"Email Not Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#6941C6",
                      backgroundColor: "#F4EBFF",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "sdrStatus",
      headerName: "SDR Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {!params?.row?.sdrcomplete ? (
                  <LeadStatusChip
                    label={"SDR Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#B54708",
                      backgroundColor: "#FFFAEB",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"SDR Complete"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "rgb(2, 122, 72)",
                      backgroundColor: "rgb(236, 253, 243)",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "event",
      headerName: "Event",
      width: 210,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {params.row.event_title
                    ? params.row.event_title
                    : "Sustenance"}
                </p>
              </div>
            }
          >
            <div
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "break-spaces",
              }}
            >
              {params.row.event_title ? params.row.event_title : "Sustenance"}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "vjSm",
      headerName: "VJ SM",
      width: 160,
      renderCell: (params) => {
        return <div>{params.row.sales_user_name}</div>;
      },
    },
    {
      field: "vjCrm",
      headerName: "VJ CRM",
      width: 180,
      renderCell: (params) => {
        return <div>{params.row.crm_user_name}</div>;
      },
    },
    {
      field: "allotedOn",
      headerName: "Alloted On",
      width: 250,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.created_at).toDateString()},{" "}
                  {new Date(params?.row?.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.created_at).toDateString()},{" "}
                {new Date(params?.row?.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      width: 270,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                  {new Date(params?.row?.last_updated_at).toLocaleTimeString(
                    [],
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                {new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  useEffect(() => {
    // if (loggedInUser?.isCrmUser && loggedInUser?.id) {
    if (loggedInUser?.id && allCrmAllotments?.length === 0) {
      getCrmAllotmentsFromServer(false);
    }
  }, [loggedInUser]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      getCrmAllotmentsFromServer(false);
    }
  }, [filterBy]);


  useEffect(() => {
    let updateUnitListener = supabase
      // .from(`CRM:requestPendingWith=eq.${loggedInUser?.id}`)
      .from(
        `CRM${!loggedInUser?.parentId
          ? ""
          : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
            "Show CRM"
          ]?.show === "All"
            ? ""
            : `:requestPendingWith=eq.${loggedInUser?.id}`
        }`
      )
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  useEffect(() => {
    let updateUnitListener = supabase
      .from(`AllotmentPayment`)
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  async function getFilterAllotmentForDatagrid(nextRange = { from: 0, to: 9 }) {
    let items = await getFilterAllotmentPagination(false, true, nextRange);
    return items;
  }

  async function getFilterAllotmentPagination(
    merge = false,
    isShowSpinner = true,
    nextRange
  ) {
    //setAllAllotments([])
    try {
      // const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.id;
      const _loggedInUserId = !loggedInUser?.parentId
        ? null
        : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Show CRM"
        ]?.show === "All"
          ? null
          : loggedInUser?.id;
      const getCrmAllotmentResponse = await getCancellationsCrmAllotments(
        _loggedInUserId,
        pageNumber?.current,
        searchValue?.current,
        filterBy,
        checked,
        selectDates,
        nextRange,
        true
      );

      if (getCrmAllotmentResponse.data) {
        getCrmAllotmentResponse.data.forEach((crmData) => {
          crmData.menuOptions = ["View CRM Details", "Timeline And Notes", "Check Virtual Account Status"];
          crmData.menuOptions.sort();
        });
        setTotalCount(getCrmAllotmentResponse.count);
        if (getCrmAllotmentResponse.data) {
          setTotalCount(getCrmAllotmentResponse.count);

          if (merge && getCrmAllotmentResponse.data.length) {
            let res = getCrmAllotmentResponse.data;

            if (!merge) {
              setAllCrmAllotments((pre) => [...res]);
              isShowSpinner && dismissLoader();
            } else {
              setAllCrmAllotments((pre) => [...pre, ...res]);
              isShowSpinner && dismissLoader();
            }
          }

          //setFilterOpen(false);
          return getCrmAllotmentResponse.data;
        }
      }
    } catch (err) {
      if (err?.message) {
        errorTost(err?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
    }
  }

  async function getCrmAllotmentsFromServer(merge, isCheckedClear = false) {
    if (!merge) {
      pageNumber.current = 0;
      hasMore.current = true;
      // setChecked([]);
    }
    mode === "Table View" && setAllCrmAllotments([]);
    const selectedDate = { ...selectDates };
    try {
      presentLoader();
      // const _loggedInUserId = loggedInUser?.id;
      // console.log("Logged In user...", _loggedInUserId);
      // const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.id;
      // const _loggedInUserId = null;
      const _loggedInUserId = !loggedInUser?.parentId
        ? null
        : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Show CRM"
        ]?.show === "All"
          ? null
          : loggedInUser?.id;
      await getCancellationsCrmAllotments(
        _loggedInUserId,
        pageNumber.current,
        searchValue?.current,
        filterBy,
        checked,
        isCheckedClear ? undefined : selectedDate,
        null,
        null,
        false
      )
        .then((getCrmAllotmentsResponse) => {
          if (getCrmAllotmentsResponse.data) {
            setTotalCount(getCrmAllotmentsResponse.count);
            getCrmAllotmentsResponse.data.forEach((crmData) => {
              crmData.menuOptions = ["View CRM Details", "Timeline And Notes", "Check Virtual Account Status"];
              crmData.menuOptions.sort();
            });
            if (merge) {
              setAllCrmAllotments((pre) => [
                ...pre,
                ...getCrmAllotmentsResponse.data,
              ]);
            } else {
              setAllCrmAllotments([...getCrmAllotmentsResponse.data]);
            }

            if (getCrmAllotmentsResponse.data.length < 10) {
              hasMore.current = false;
            }
            dismissLoader();
          } else {
            throw getCrmAllotmentsResponse;
          }
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });

      await getCancellationsCrmAllotments(
        _loggedInUserId,
        pageNumber.current,
        searchValue?.current,
        filterBy,
        merge ? checked : [],
        isCheckedClear ? undefined : selectedDate,
        null,
        null,
        true
      )
        .then((emailSentData) => {
          setEmailSentCount(emailSentData.data.length);
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
    } catch (error) {
      if (error?.status === 416) {
        hasMore.current = false;
      } else if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }
  const closeCrmModal = () => {
    setcrmTimeLineModalToggle(false);
  };


  const debouncedFetchSearchData = debounce((e) => {
    searchValue.current = e.target.value;
    pageNumber.current = 0;
    hasMore.current = true;
    getCrmAllotmentsFromServer(false);
  }, 800);

  const allotmentCard = allCrmAllotments.map((allotment, index) => {
    return (
      <Grid
        className={classes.Grid}
        item
        xs={4}
        sm={4}
        md={4}
        lg={4}
        key={"allotmentCard" + index}
      >
        <Card className={cssClasses.eventWrap} key={allotment?.id}>
          {/* {allotment?.is_approved && <div className={cssClasses.allotmentApprovedLabel}>Approved</div>} */}
          <div className={cssClasses.cardHeader}>
            <div className={cssClasses.tokenNumWrap}>
              {!allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {allotment?.displaywingname
                    ? allotment?.displaywingname
                    : allotment?.wing_name}{" "}
                  - {allotment?.unit_no}{" "}
                </span>
              )}
              {allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {/* {allotment?.merged_wing_name} -{" "} */}
                  {allotment?.mergeddisplaywingname
                    ? allotment?.mergeddisplaywingname
                    : allotment?.merged_wing_name}{" "}
                  - {allotment?.merged_unit_no_one} {"-"}{" "}
                  {allotment?.merged_unit_no_two}{" "}
                </span>
              )}
              <span>|</span>
              {!allotment?.inventory_merge_id && (
                <span>{allotment?.project_name}</span>
              )}
              {allotment?.inventory_merge_id && (
                <span>{allotment?.merged_project_name}</span>
              )}
            </div>
            {allotment?.unitof && <div><LeadStatusChip
              label={allotment?.unitof}
              style={{
                color: "#3538CD",
                backgroundColor: "#EEF4FF",
              }}
            /></div>}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper}>
              {/* Status */}
              <div className={cssClasses.tokenStatus}>
                {allotment?.status && (
                  <LeadStatusChip
                    label={allotment?.status}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                )}
              </div>
              <div className={cssClasses.tokenStatus}>
                {allotment?.isemailsent && (
                  <LeadStatusChip
                    label={"Email Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#6941C6", backgroundColor: "#F4EBFF" }}
                  />
                )}
              </div>
            </div>
            <div className={cssClasses.tokenActions}>
              <ThreeDotsMenu
                list={allotment?.menuOptions}
                selectedValue={(e) => {
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(allotment.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                  if (e === "View CRM Details") {
                    let _allotment = {
                      ...allotment,
                      allotmentPaymentId: {
                        paidAmt: allotment.paidamt,
                        unitCost: allotment.unitcost,
                        allotmentPaymentId: allotment.allotment_payment_id,
                        applicationApiRes: allotment?.application_api_res,
                        "100AmrRes": allotment?.amr_100_res,
                        "100B2bRes": allotment?.b2b_100_res,
                        GstAmrRes: allotment?.gst_amr_res,
                        gstB2bRes: allotment?.gst_b2b_res,
                        SdrB2bRes: allotment?.sdr_b2b_res,
                        WithoutTdsRes: allotment?.without_tds_res,
                      },
                    };
                    setSelectedAllotmentForViewCrmDetails(_allotment);
                  }
                  if (e === "Timeline And Notes") {
                    setAllotmentData(allotment)
                    setcrmTimeLineModalToggle(true);
                  }
                }}
              />
            </div>
          </div>
          <div
            className={cssClasses.leadDetailsDiv}
            style={{ flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                className={cssClasses.tokenNumWrap}
                style={{ alignItems: "baseline" }}
              >
                <p>{allotment?.lead_name}</p>
                <p
                  style={{
                    fontFamily: "Inter-Regular",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "1.4rem",
                    lineHeight: "1.8rem",
                    color: "#667085",
                  }}
                >
                  {"VJ" +
                    allotment?.leaddisplayid
                      ?.toString()
                      ?.replace(
                        allotment?.leaddisplayid?.toString()?.substring(8, 12),
                        "-" +
                        allotment?.leaddisplayid?.toString()?.substring(8, 12)
                      )}
                </p>
              </div>
              <div
                className={cssClasses.allotmentPaymentId}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p>+{allotment?.bookingformcontactnumber}</p>
                <a
                  href={`tel:+${allotment?.bookingformcontactnumber}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CallIcon
                    style={{ width: "3rem", height: "3rem" }}
                    round={true}
                  />
                </a>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <p style={{ color: "darkgray", fontSize: "1.4rem" }}>
                {allotment?.allotment_payment_id}
              </p>
            </div>
            {/* <div style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "start",
              marginTop: "1rem",
              width: "100%"
            }}>
              {allotment?.leadvjop && <div><LeadStatusChip
                            label="VJOP"
                            style={{
                              color: "rgb(180, 35, 24)",
                              backgroundColor: "rgb(254, 243, 242)",
                            }}
                          /></div>}
              {allotment?.leadvjop &&
                (allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
                  <LeadStatusChip
                    label="VJOP-LOYALTY"
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                      fontSize: "0.85rem",
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label="VJOP"
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                      fontSize: "0.85rem",
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  />
                ))}
            </div> */}
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "start",
                marginTop: "1rem",
                width: "100%",
              }}
            >
              {allotment?.leadvjop ? (
                allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
                  <LeadStatusChip
                    label="VJOP-LOYALTY"
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                      fontSize: "0.85rem",
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label="VJOP"
                    style={{
                      color: "rgb(180, 35, 24)",
                      backgroundColor: "rgb(254, 243, 242)",
                      fontSize: "0.85rem",
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  />
                )
              ) : (
                allotment?.leadtype && (
                  <LeadStatusChip
                    label={allotment.leadtype}
                    style={{
                      color: "rgb(24, 90, 180)",
                      backgroundColor: "rgb(240, 247, 255)",
                      fontSize: "0.85rem",
                      minWidth: "140px",
                      textAlign: "center",
                    }}
                  />
                )
              )}
            </div>
          </div>
          <div className={cssClasses.cardDetails}>
            <div className={cssClasses.tokenDetails}>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <span>
                  {" "}
                  {allotment?.event_title
                    ? allotment?.event_title
                    : "Sustenance "}{" "}
                </span>
                <div className={cssClasses.tokenLastUpdate}>
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={allotment?.last_updated_at ?? allotment?.created_at}
                    locale="en-US"
                  />
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div className={cssClasses.tokenLastUpdate} style={{ flex: 1 }}>
                  <p>VJ SM - {allotment?.sales_user_name}</p>
                  {/* <p>VJ SM - {allotment.cpbillingname}</p> */}
                  {/* { allotment?.allotmentPaymentId?.crmuserid && allotment?.allotmentPaymentId?.crmusername && <p>VJ CRM - {allotment?.allotmentPaymentId?.crmusername}</p>} */}
                  {allotment?.crm_user_name && allotment?.crm_user_name && (
                    <p>VJ CRM - {allotment?.crm_user_name}</p>
                  )}
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  {allotment?.display_inventory_type?.includes(
                    "Inventory Type"
                  ) && <span>{allotment?.inventory_type}</span>}
                  {allotment?.display_inventory_type?.includes(
                    "Display Unit Type"
                  ) && <span>{"(" + allotment?.display_unit_type + ")"}</span>}
                  {!allotment?.inventory_type && <span>Merged</span>}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>Alloted By: </span>
                  <span>{allotment?.allotedbyuser}</span>
                </div>
                <div>
                  <span>Alloted On: </span>
                  <span>
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toDateString()},{" "}
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {allotment?.paymentplantitle &&
            <div style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              fontSize: "1.4rem",
              color: "rgba(220, 104, 3, 1)",
            }}>
              <span style={{ textTransform: "capitalize" }}>Payment Plan {allotment?.paymentplantitle} is selected.</span>
            </div>}
        </Card>
      </Grid>
    );
  });

  return (
    <>
      <div className={cssClasses.content}>
        <div
          className={cssClasses.actionWrapper}
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <div className={cssClasses.countWrapper}>
            <p>{totalCount} Cancellations</p>
            <p>{emailSentCount} Total Email Sent</p>
          </div>
          <div className={cssClasses.filterContainer}>
            <div className={cssClasses?.filterWrapper}>
              {/* start filter implements */}
              <AllotmentFilter
                depStr={depStr}
                setDepQuery={setDepQuery}
                checked={checked}
                setChecked={setChecked}
                hasMore={hasMore}
                selectDates={selectDates}
                setSelectDates={setSelectDates}
                setAllCrmAllotments={setAllCrmAllotments}
                getCrmAllotmentsFromServer={getCrmAllotmentsFromServer}
                _loggedInUserId={null}
                pageNumber={pageNumber}
                isCancellationTab={true}
              />

              {/* end filter implements */}
              <AllotmentSortFilter
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                allCrmAllotments={allCrmAllotments}
                setAllCrmAllotments={setAllCrmAllotments}
              />
              {/* <ViewToggleSwitch setMode={setMode} /> */}
            </div>
            <div
              className={cssClasses.searchWrapper}
              style={{ display: "flex", alignItems: "center", gap: "15px" }}
            >
              <SearchBar
                width="254px"
                sxStyle={{
                  "& input": {
                    fontSize: "1.3rem !important",
                    fontFamily: "Inter-Medium !important",
                  },
                }}
                placeholder={"Search by Lead Name Or Unit No"}
                search={debouncedFetchSearchData}
                id={"tagPendingCrmAllotmentLeadName"}
              />
            </div>
          </div>
        </div>

        {allCrmAllotments.length > 0 ? (
          mode === "Card View" ? (
            <Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
              <Box sx={{ flexGrow: 1 }}>
                <InfiniteScroll
                  dataLength={allCrmAllotments.length}
                  next={() => {
                    if (hasMore.current) {
                      pageNumber.current = pageNumber.current + 1;
                      getCrmAllotmentsFromServer(true);
                    }
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                  }} //To put endMessage and loader to the top.
                  hasMore={hasMore}
                  // loader={<p className={cssClasses.infiniteScrollLoadingText}>Loading...</p>}
                  scrollableTarget="scrollableDiv"
                >
                  <Grid
                    style={{
                      marginTop: "0rem",
                      marginBottom: "1rem",
                      marginLeft: "0rem",
                      width: "100%",
                    }}
                    container
                    spacing={{ xs: 2, md: 3, lg: 3 }}
                    columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                  >
                    {allotmentCard}
                  </Grid>
                </InfiniteScroll>
              </Box>
            </Box>
          ) : (
            <div className={cssClasses.tableContainer}>
              <ServerPaginationGrid
                sx={{
                  "& .MuiDataGrid-columnHeaders + div": {
                    height: "calc(100vh - 440px) !important",
                  },
                }}
                name="crm-change-plans"
                rows={allCrmAllotments}
                columns={tagGridColumns}
                depStr={depStr}
                count={totalCount}
                getDataByPage={getFilterAllotmentForDatagrid}
              />
            </div>
          )
        ) : (
          <div style={{ height: "100%" }}>
            <p
              style={{
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                fontSize: "3rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={EmptyState} alt="No Data" />
                <span>No Allotment Available</span>
              </div>
            </p>
          </div>
        )}
      </div>
      {selectedAllotmentForViewCrmDetails && (
        <ViewAllotedCrmDetailsModal
          selectedAllotmentObject={selectedAllotmentForViewCrmDetails}
          open={Boolean(selectedAllotmentForViewCrmDetails)}
          handleClose={(_result) => {
            setSelectedAllotmentForViewCrmDetails(null);
          }}
        />
      )}
      {crmTimeLineModalToggle && (
        <CrmTimeLineModal
          open={true}
          data={allotmentData}
          handleClose={closeCrmModal}
        />
      )}
      {virtualAccountStatusModal && (
        <UpdateLeadDetails open={virtualAccountStatusModal}
          handleClose={() => {
            setVirtualAccountStatusModal(false);
          }}
          leadDisplayId={leadDisplayId}
        />
      )}
    </>
  );
}

export default Cancellations;

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}